import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Card, { CardActions, CardContent } from 'material-ui/Card'
import Button from 'material-ui/Button'

// Actions
import { saveData } from './actions'

function getParameterByName(name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

var data1 = ''
var data2 = ''
var data3 = ''
var data4 = ''
var data5 = ''
var data6 = ''
var data7 = ''
var data8 = ''

class PriorityColor extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dsc1: 'Loading...',
      dsc2: 'Loading...',
      dsc3: 'Loading...',
      dsc4: 'Loading...',
      dsc5: 'Loading...',
      clr1: 'Loading...',
      clr2: 'Loading...',
      clr3: 'Loading...',
      popLoaded: false,
      saved_search_id: '',
      count: 0,
      name: '',
      pref_fans: 0
    }
  }

  get8(number) {
    let myComponent = this
    let currentComponent = this
    let url8 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/0/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/3/clrlow/3/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    //alert(urls[number -1])
    axios.get(url8).then(function(response) {
      if (response.data) {
        //console.log(JSON.stringify(response.data))
        if (Array.isArray(response.data)) {
          let s = JSON.stringify(response.data[0]).toString()
          data8 = s.split('SearchCount":')[1].replace('}', '')
          console.log(data8)
          myComponent.setCounts()
        } else {
          //myComponent.get8()
        }
      } else {
        //myComponent.get8()
      }
    })
  }

  get7(number) {
    let myComponent = this
    let currentComponent = this
    let url7 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/0/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/2/clrlow/2/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    //alert(urls[number -1])
    axios.get(url7).then(function(response) {
      if (response.data) {
        if (Array.isArray(response.data)) {
          //console.log(JSON.stringify(response.data))
          let s = JSON.stringify(response.data[0]).toString()
          data7 = s.split('SearchCount":')[1].replace('}', '')
          console.log(data7)
          myComponent.get8()
        } else {
          //myComponent.get7()
        }
      } else {
        //  myComponent.get7()
      }
    })
  }

  get6(number) {
    let myComponent = this
    let currentComponent = this
    let url6 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/0/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/1/clrlow/1/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    //alert(urls[number -1])
    axios.get(url6).then(function(response) {
      if (response.data) {
        if (Array.isArray(response.data)) {
          let s = JSON.stringify(response.data[0]).toString()
          data6 = s.split('SearchCount":')[1].replace('}', '')
          console.log(data6)
          myComponent.get7()
        } else {
          //myComponent.get6()
        }
      } else {
        //myComponent.get6()
      }
    })
  }

  get5(number) {
    let myComponent = this
    let currentComponent = this
    let url5 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/5/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/4/clrlow/1/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    //alert(urls[number -1])
    axios.get(url5).then(function(response) {
      if (response.data) {
        if (Array.isArray(response.data)) {
          let s = JSON.stringify(response.data[0]).toString()
          data5 = s.split('SearchCount":')[1].replace('}', '')
          console.log(data5)
          myComponent.get6()
        } else {
          //  myComponent.get5()
        }
      } else {
        //  myComponent.get5()
      }
    })
  }

  get4(number) {
    let myComponent = this
    let currentComponent = this
    let url4 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/4/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/5/clrlow/0/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    //alert(urls[number -1])
    axios.get(url4).then(function(response) {
      if (response.data) {
        if (Array.isArray(response.data)) {
          let s = JSON.stringify(response.data[0]).toString()
          data4 = s.split('SearchCount":')[1].replace('}', '')
          console.log(data4)
          myComponent.get5()
        } else {
          //  myComponent.get4()
        }
      } else {
        //  myComponent.get4()
      }
    })
  }

  get3(number) {
    let myComponent = this
    let currentComponent = this
    let url3 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/3/dsclow/3/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/5/clrlow/0/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    //alert(urls[number -1])
    axios.get(url3).then(function(response) {
      if (response.data) {
        if (Array.isArray(response.data)) {
          let s = JSON.stringify(response.data[0]).toString()
          data3 = s.split('SearchCount":')[1].replace('}', '')
          console.log(data3)
          myComponent.get4()
        } else {
          //myComponent.get3()
        }
      } else {
        //myComponent.get3()
      }
    })
  }

  get2(number) {
    let myComponent = this
    let currentComponent = this
    let url2 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/2/dsclow/2/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/5/clrlow/0/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    //alert(urls[number -1])
    axios.get(url2).then(function(response) {
      if (response.data) {
        if (Array.isArray(response.data)) {
          let s = JSON.stringify(response.data[0]).toString()
          data2 = s.split('SearchCount":')[1].replace('}', '')
          console.log(data2)
          myComponent.get3()
        } else {
          //myComponent.get2()
        }
      } else {
        //  myComponent.get2()
      }
    })
  }

  get1() {
    let myComponent = this
    let currentComponent = this
    let url1 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/1/dsclow/1/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/5/clrlow/0/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    //alert(urls[number -1])
    axios.get(url1).then(function(response) {
      if (response.data) {
        if (Array.isArray(response.data)) {
          let s = JSON.stringify(response.data[0]).toString()
          data1 = s.split('SearchCount":')[1].replace('}', '')
          console.log(data1)
          myComponent.get2()
        } else {
          //myComponent.get1()
        }
      } else {
        //myComponent.get1()
      }
    })
  }

  setCounts() {
    this.setState({
      dsc1: data1 + ' Candidates.',
      dsc2: data2 + ' Candidates.',
      dsc3: data3 + ' Candidates.',
      dsc4: data4 + ' Candidates.',
      dsc5: data5 + ' Candidates.',
      clr1: data6 + ' Candidates.',
      clr2: data7 + ' Candidates.',
      clr3: data8 + ' Candidates.',
      popLoaded: true
    })
  }

  async getDSCPopulation() {
    let currentComponent = this

    let url1 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/1/dsclow/1/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/5/clrlow/0/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url2 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/2/dsclow/2/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/5/clrlow/0/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url3 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/3/dsclow/3/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/5/clrlow/0/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url8 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/3/clrlow/3/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url7 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/2/clrlow/2/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url6 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/1/clrlow/1/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url5 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/5/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/4/clrlow/1/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number
    let url4 =
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/4/agehigh/' +
      currentComponent.state.age_high +
      '/agelow/' +
      currentComponent.state.age_low +
      '/oarhigh/' +
      currentComponent.state.oar_high +
      '/oarlow/' +
      currentComponent.state.oar_low +
      '/herprefage/' +
      currentComponent.state.herprefage +
      '/herprefans/' +
      currentComponent.state.pref_fans +
      '/clrhigh/5/clrlow/0/education/' +
      currentComponent.state.education +
      '/income/' +
      currentComponent.state.income +
      '/cust/' +
      this.props.customer_number

    await axios
      .get('https://dsn-dev.appspot.com/v1/proxy', {
        params: {
          type: 'filters',
          url1: url1,
          url2: url2,
          url3: url3,
          url4: url4,
          url5: url5,
          url6: url6,
          url7: url7,
          url8: url8
        }
      })
      .then(function(response) {
        let data1 = response.data[0]['url1']
        let data2 = response.data[1]['url2']
        let data3 = response.data[2]['url3']
        let data4 = response.data[3]['url4']
        let data5 = response.data[4]['url5']
        let data6 = response.data[5]['url6']
        let data7 = response.data[6]['url7']
        let data8 = response.data[7]['url8']

        currentComponent.setState({
          dsc1: data1 + ' Candidates.',
          dsc2: data2 + ' Candidates.',
          dsc3: data3 + ' Candidates.',
          dsc4: data4 + ' Candidates.',
          dsc5: data5 + ' Candidates.',
          clr1: data6 + ' Candidates.',
          clr2: data7 + ' Candidates.',
          clr3: data8 + ' Candidates.',
          popLoaded: true
        })
      })

    /*
    axios.post('https://dsn-dev.appspot.com/v1/proxy', {
      'url1':url1,
      'url2':url2,
      'url3':url3,
      'url4':url4,
      'url5':url5,
      'url6':url6,
      'url7':url7,
      'url8':url8
    }).then(function (response) {
      console.log(response);
      alert(response)
    }).catch(function (error) {
      console.log(error);
      alert(error);
    });*/

    //this.get1()
    /*
    alert(url1)
    alert(url2)
    alert(url3)
    alert(url4)
    alert(url5)
    alert(url6)
    alert(url7)
    alert(url8)
*/
    /*
    // DSC Code 1
    console.log(` url 1 is ${url1}`)
    axios.get(url1).then(function(response) {
          data1 = response.data[0]["SearchCount"]

          // DSC Code 2
          console.log(` url 2 is ${url2}`)
          axios.get(url2).then(function(response) {
                data2 = response.data[0]["SearchCount"]

                // DSC Code 3
                axios.get(url3).then(function(response) {
                      data3 = response.data[0]["SearchCount"]

                      // DSC Code 4
                      axios.get(url4).then(function(response) {
                            data4 = response.data[0]["SearchCount"]

                            // DSC Code 5
                            axios.get(url5).then(function(response) {
                                  data5 = response.data[0]["SearchCount"]


                                  // CLR Code 1
                                  axios.get(url6).then(function(response) {
                                        data6 = response.data[0]["SearchCount"]

                                        // CLR Code 2
                                        axios.get(url7).then(function(response) {
                                              data7 = response.data[0]["SearchCount"]

                                              // CLR Code 3
                                              axios.get(url8).then(function(response) {
                                                    data8 = response.data[0]["SearchCount"]

                                                    currentComponent.setState({
                                                      dsc1: data1+" Candidates.",
                                                      dsc2: data2+" Candidates.",
                                                      dsc3: data3+" Candidates.",
                                                      dsc4: data4+" Candidates.",
                                                      dsc5: data5+" Candidates.",
                                                      clr1: data6+" Candidates.",
                                                      clr2: data7+" Candidates.",
                                                      clr3: data8+" Candidates.",
                                                      popLoaded: true,
                                                    })

                                              });

                                        });

                                  });
                            });
                      });
                });
          });
    });*/
  }

  isNumeric(value) {
    return /^-{0,1}\d+$/.test(value)
  }

  async getSavedSearch() {
    let myComponent = this
    //alert(this.props.filter_id);
    if (
      !this.state.saved_search_id.isNaN &&
      this.isNumeric(this.state.saved_search_id)
    ) {
      let url =
        'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/customer/' +
        this.props.customer_number +
        '/pw/teSt1/fltr/' +
        this.props.filter_id +
        '/db/2'
      //alert(url);
      await axios.get(url).then(function(response) {
        if (response.data) {
          //alert(JSON.stringify(response.data[0]))
          let data = response.data[0]

          if (data['Search_Name'] === 'All Candidates') {
            myComponent.setState(
              {
                oar_high: 10,
                oar_low: 7,
                age_high: 54,
                age_low: 0,
                herprefage: 15,
                education: -1,
                income: -1,
                pref_fans: 0
              },
              function() {
                myComponent.getDSCPopulation()
              }
            )
          } else {
            //alert(JSON.stringify(response.data[0]));

            let education = data.Education_Low
            let income = data.Income_Low

            if (education == 0) {
              education = -1
            }
            if (income == 0) {
              income = -1
            }

            myComponent.setState(
              {
                oar_high: data.Oar_High,
                oar_low: data.Oar_Low,
                age_high: data.Oldest_Dating_Age,
                age_low: data.Youngest_Dating_Age,
                herprefage: data.Profile_Oldest_Dating_Age,
                education: education,
                income: income,
                pref_fans: data.Include_NA
              },
              function() {
                myComponent.getDSCPopulation()
              }
            )
          }
        } else {
          myComponent.getSavedSearch()
        }
      })
    } else {
      this.props.changeRoute('/console/search/saved_searches')
    }
  }

  componentDidMount() {
    let name = getParameterByName('name')
    let count = getParameterByName('count')
    let id = getParameterByName('search_id')
    /*
    alert(id)
    alert(name)
    alert(count)
    */

    if (
      name != 'undefined' &&
      count != 'undefined' &&
      id != 'undefined' &&
      id != null &&
      !isNaN(id) &&
      typeof id != 'undefined'
    ) {
      this.setState(
        {
          saved_search_id: Number(id),
          count: count,
          name: name
        },
        function() {
          this.getSavedSearch()

          if (this.props.filter_id === 'not set') {
            this.props.changeRoute('/console/search/saved_searches')
          } else {
            this.getSavedSearch()
          }
        }
      )
    } else {
      this.props.changeRoute('/console/search/saved_searches')
    }
  }

  onSelectDatingCode(dsc) {
    if (this.state.popLoaded) {
      this.props.saveData(
        dsc,
        4,
        'dsc',
        this.state.oar_low,
        this.state.oar_high,
        this.state.age_low,
        this.state.age_high,
        this.state.herprefage,
        this.state.income,
        this.state.education,
        this.state.pref_fans
      )

      if (dsc == 5) {
        this.props.changeRoute(
          '/console/search/saved_searches/results?l=show_omit'
        )
      } else {
        this.props.changeRoute('/console/search/saved_searches/results/')
      }
    } else {
      alert('Please wait for the population counts to load.')
    }
  }

  onSelectColor(clr) {
    if (this.state.popLoaded) {
      this.props.saveData(
        4,
        clr,
        'clr',
        this.state.oar_low,
        this.state.oar_high,
        this.state.age_low,
        this.state.age_high,
        this.state.herprefage,
        this.state.income,
        this.state.education,
        this.state.pref_fans
      )
      this.props.changeRoute('/console/search/saved_searches/results/')
    } else {
      alert('Please wait for the population counts to load.')
    }
  }

  onSelectNoFilter() {
    this.props.saveData(
      5,
      4,
      'none',
      this.state.oar_low,
      this.state.oar_high,
      this.state.age_low,
      this.state.age_high,
      this.state.herprefage,
      this.state.income,
      this.state.education,
      this.state.pref_fans
    )
    this.props.changeRoute('/console/search/saved_searches/results/')
  }

  render() {
    const { classes, theme, location } = this.props
    const id = '1'

    let name = getParameterByName('name')
    let count = getParameterByName('count')

    return (
      <div className={classes.content}>
        <div className={classes.buttonNoFilter}>
          <Typography type="body2">Active Population Count: {count}</Typography>
        </div>
        <div className={classes.buttonNoFilter}>
          <Typography type="body2">
            Selected Filter: {name.split('?count')[0]}
          </Typography>
          <Typography>Click Below to Add Sub-Filter:</Typography>
        </div>
        <br />
        <br />
        <Card className={classes.card}>
          <CardContent>
            <Typography>By Color Notification:</Typography>
            <br />
            <Button
              className={classes.buttonYellow}
              raised
              onClick={() => this.onSelectColor(3)}
            >
              New Candidates Only
            </Button>
            <Typography>{this.state.clr3}</Typography>
            <br />
            <Button
              className={classes.button}
              raised
              onClick={() => this.onSelectColor(1)}
            >
              Returning Candidates Only
            </Button>
            <Typography>{this.state.clr1}</Typography>
            <br />
            <Button
              className={classes.buttonLightGreen}
              raised
              onClick={() => this.onSelectColor(2)}
            >
              Needs Response
            </Button>
            <Typography>{this.state.clr2}</Typography>
            <br />
          </CardContent>
        </Card>
        <div className={classes.space} />
        <Card className={classes.card}>
          <CardContent>
            <Typography>By Priority Code:</Typography>
            <br />
            <Button
              className={classes.buttonDating}
              raised
              color="primary"
              onClick={() => this.onSelectDatingCode(1)}
            >
              Dating
            </Button>
            <Typography>{this.state.dsc1}</Typography>
            <br />
            <Button
              className={classes.buttonPursuing}
              raised
              color="primary"
              onClick={() => this.onSelectDatingCode(2)}
            >
              Actively Pursuing
            </Button>
            <Typography>{this.state.dsc2}</Typography>
            <br />
            <Button
              className={classes.buttonWaiting}
              raised
              color="primary"
              onClick={() => this.onSelectDatingCode(3)}
            >
              Waiting to Hear
            </Button>
            <Typography>{this.state.dsc3}</Typography>
            <br />
            <Button
              className={classes.buttonGaveUp}
              raised
              color="primary"
              onClick={() => this.onSelectDatingCode(4)}
            >
              Gave Up For Now
            </Button>
            <Typography>{this.state.dsc4}</Typography>
            <br />
            <Button
              className={classes.buttonBlack}
              raised
              color="primary"
              onClick={() => this.onSelectDatingCode(5)}
            >
              Show Omitted
            </Button>
            <Typography>{this.state.dsc5}</Typography>
            <br />
          </CardContent>
        </Card>
        <div className={classes.space} />
        <div className={classes.buttonNoFilter}>
          <Button
            className={classes.buttonNoFilter}
            align="center"
            color="primary"
            onClick={() => this.onSelectNoFilter()}
          >
            No Sub Filter
          </Button>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    filter_id: state.saved.filter_id
  }
}

function matchDispatchToProps(dispatch) {
  return {
    saveData: bindActionCreators(saveData, dispatch),
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, matchDispatchToProps)(PriorityColor)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Filters/scenes/PriorityColor/index.js